module.exports = __webpack_public_path__ + "img/add-departure-canceled-climbing-table-icon.c3bfa4b8.svg";